<template>
  <div :class="{'glowbe': true, 'glowbe--is-pulsing': pulse}">
    <div class="glowbe-inner"></div>
    <div class="glowbe-outer"></div>
  </div>
  
</template>

<script>
export default {
  name: "Glowbe",
  props: ["pulse"],
};
</script>

<style>

.glowbe {
  --x: 0px;
  --y: 0px;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  position: relative;
  /* transition: all 50ms cubic-bezier(0.18, 0.3, 0.39, 0.5);
  transform: translate(var(--x), var(--y)); */
}

.glowbe.glowbe--is-pulsing {
  animation: pulse 2.75s infinite alternate;
  animation-timing-function: ease-in-out;
}

@keyframes pulse {
  0% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

.glowbe-inner {
  position: absolute;
  background-color: white;
  filter: blur(5px);
  height: 100%;
  width: 100%;
  border-radius: 50%;
}

.glowbe-outer {
  position: absolute;
  background: #2097ED;
  filter: blur(15px);
  height: 100%;
  width: 100%;
  border-radius: 50%;
  opacity: 1;
}

</style>